var indentation_default = {
  "indentZero": "xHBmq",
  "indentOne": "_6ZYLQ",
  "indentTwo": "qcn1t",
  "indentThree": "bD--u",
  "indentFour": "_1KUzp",
  "indentFive": "A6-cy",
  "indentSix": "yqOA5"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
